
import { Component, Mixins, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { TabDto } from '@/api/goodsModule'
import scroll from '@/mixins/scroll'
import contentModule from '@/views/industryMall/goods/contentModule.vue'

@Component({
  name: 'Goods',
  components: {
    contentModule
  }
})
export default class goods extends Mixins(scroll) {
  @Getter partnerCompanyId!: string
  @Getter companyId!: string
  @Getter tabModules!: Array<TabDto>
  active = 0

  get isTabModule () {
    return this.tabModules.find(t => t.route === '/goods')?.isShow ?? true
  }

  @Watch('active')
  onActiveChange () {
    console.log('watch active ***', this.active)
  }
}
